import kya_mujhe_pyaar from "./assets/kya_mujhe_pyaar.mp3";
import laboon_ko from "./assets/laboon_ko.mp3";
import mast_magan from "./assets/mast_magan.mp3";
import nakhre from "./assets/nakhre.mp3";
import dil_ko from "./assets/dil_ko.mp3";
import kabhi_jo from "./assets/kabhi_jo.mp3";
import rhtdm from "./assets/rhtdm.mp3";







import './App.css';
import Main from './Components/Main';
import { useState } from 'react';
import Loader from './Components/Loader';
import Sidebar from './Components/Sidebar';
    //img: "https://i1.sndcdn.com/artworks-2GyNyw85zwTrW9PI-RM5CMg-t500x500.jpg",
    //img: "https://a10.gaanacdn.com/images/albums/88/5051888/crop_480x480_5051888.jpg",
    //img: "https://i.scdn.co/image/ab67616d0000b273d37fabc262bcdf3cc3c89553",
    //   

const data = [
  {
    id: 1,
    name: "Kya Mujhe Slowed & Reverb",
    song: kya_mujhe_pyaar,
    desc: "Slowed Kya mujhe pyaar by KK",
    img: "https://i1.sndcdn.com/artworks-Jc5yJMyre7kVrzhj-fbdDxg-t500x500.jpg",
  },
  {
    id: 2,
    name: "Laboon Ko by KK Slowed",
    song: laboon_ko,
    desc: "Slowed & Reverb Laboon Ko song by KK",
    img: "https://images.hungama.com/c/1/603/c32/85778719/85778719_300x300.jpg",
  },
  {
    id: 3,
    name: "Slowed Nakhre",
    song: nakhre,
    desc: "Slowed & Reverb Nakhre by Zack Knight",
    img: "https://i1.sndcdn.com/artworks-2GyNyw85zwTrW9PI-RM5CMg-t500x500.jpg",
  },
  {
    id: 4,
    name: "Arjit Singh Lofi",
    song: mast_magan,
    desc: "1 hour of Lofi Songs by Arjit Singh",
    img: "https://i1.sndcdn.com/artworks-h37XMNbMHw7mtQIy-E7g6YA-t500x500.jpg",
  },
  {
    id: 5,
    name: "RHTDM flute ",
    song: rhtdm,
    desc: "RHTDM flute music",
    img: "https://e.snmc.io/i/600/s/2ec8e59df7a0aa03ddac46a99fb995d3/8496108/montell-fish-bedroom-lofi-Cover-Art.jpg",
  },
  {
    id: 6,
    name: "Kabhi Jo Badal",
    song: kabhi_jo,
    desc: "Kabhi Jo Badal barse by Arijit",
    img: "https://angartwork.akamaized.net/?id=143539604&size=640",
  },
  {
    id: 7,
    name: "Dil ko Karaar",
    song: dil_ko,
    desc: "Dil ko karaar slowed and reverb",
    img: "https://i.scdn.co/image/ab67616d0000b2738cf47bc256b732a9467e61bb",
  },
];


function App() {

  const [sidebar,setSidebar]=useState(false)
  const [playList,setPlaylist]=useState(data)
  const [current,setCurrent]=useState(data[0])
  const [playing,setPlaying]=useState(false)

  const changeSong=(newId)=>{
    closeSidebar()
    setCurrent(playList[newId-1])
    setPlaying(true);

  }


  const nextSong=()=>{
    console.log(current.id,playList.length)
        if (current.id == playList.length-1) {
          setCurrent(playList[0]);
        } else {
          setCurrent(playList[current.id+1]);
        }
          setPlaying(true);
  }
  const prevSong=()=>{
    if (current.id===0) {
        setCurrent(playList[playList.length - 1]);
    } else {
      setCurrent(playList[current.id - 1]);
    }
          setPlaying(true);
  }

  const closeSidebar=()=>{
    document.getElementById('sidebar').style.right="-100%";
  }

  const showSidebar=()=>{
    document.getElementById('sidebar').style.right="0";
  }

  return (
    <div className="app">
      <Main
        showSidebar={showSidebar}
        currentSong={current}
        nextSong={nextSong}
        prevSong={prevSong}
        playing={playing}
        setPlaying={setPlaying}
      />
      <Sidebar
        closeSidebar={closeSidebar}
        currentSong={current}
        playList={playList}
        nextSong={nextSong}
        prevSong={prevSong}
        changeSong={changeSong}
        playing={playing}
        setPlaying={setPlaying}
      />
    </div>
  );
}

export default App;
